/**
 * Created by yuri on 9/17/15.
 */
/*
 Pipl Lazy image loading.
 Base on the project of
 A lazy loading and multi-serving image script
 (c) Bjoern Klinggaard - @bklinggaard - http://dinbror.dk/blazy
 */

;(function (window) {
  var lazyLoaderManager = function () {
    this.pool = []
  }
  lazyLoaderManager.prototype = {
    create: function (settings) {
      var ins = new lazyLoaderPipl(settings)
      this.pool.push(ins)
      return ins
    },
    length: function () {
      return this.pool.length
    },
    validatteAll: function () {
      //for each lazyLoader Instance Run "validate" function
      for (var i in this.pool) {
        this.pool[i].validate()
      }
    },
    forceLoad: function (callback) {
      for (var i in this.pool) {
        this.pool[i].force = true
        this.pool[i].validate()
      }

      if (typeof callback != 'undefined') {
        var self = this
        var isFinished = false

        // pooling function to verify all images been loaded.
        var timeoutLoading = setInterval(function () {
          for (var i in self.pool) {
            if (!self.pool[i].allImagesLoaded())
              return false
          }
          clearInterval(timeoutLoading)
          callback()
          isFinished = true
        }, 250)

        // Terminate the interval above, when images are stuck loading.
        setTimeout(function () {
          if (!isFinished) {
            clearInterval(timeoutLoading)
            callback()
          }
        }, 10000)
      }
    },
    getImages: function () {
      let images = []
      for (var i in this.pool) {
        images = images.concat(this.pool[i].images)
      }
      return images
    }

  }

  var lazyLoaderPipl = function (options) {
    this.options = {}
    this.viewport = {}
    this.destroyed = true
    this.source = null
    this.count = 0
    this.isRetina = true
    options.error = options.error || false
    options.offset = options.offset || 100
    options.success = options.success || false
    options.finish = options.finish || false
    options.selector = options.selector || '.b-lazy'
    options.parentContainer = options.parentContainer || document
    options.separator = options.separator || '|'
    options.container = options.container ? document.querySelectorAll(options.container) : false
    options.errorClass = options.errorClass || 'b-error'
    options.breakpoints = options.breakpoints || false
    options.successClass = options.successClass || 'b-loaded'
    options.src = options.src || 'data-src'
    this.source = options.source
    options.loadFirst = options.loadFirst || false
    this.options = options
    this.images = []
    this.isRetina = window.devicePixelRatio > 1
    this.viewport.top = 0 - options.offset
    this.viewport.left = 0 - options.offset
    this.loadedImages = 0, this.imagesLoadSuccessfuly = 0, this.imagesStartToLoading = 0
    this.loadAll = false
    this.force = false

    this.saveViewportOffset()
    this.initialize()
  }
  lazyLoaderPipl.prototype = {
    initialize: function () {
      var self = this
      this.createImageArray(this.options.selector)
      if (this.destroyed) {
        this.destroyed = false
        var validateT = this.validateT()
        var saveViewportOffsetT = this.saveViewportOffsetT()
        if (this.options.container) {
          this.each(this.options.container, function (object) {
            self.bindEvent(object, 'scroll', validateT)
          })
        }

        this.bindEvent(window, 'resize', saveViewportOffsetT)
        this.bindEvent(window, 'scroll', validateT)
        this.bindEvent(window, 'resize', validateT)
      }
      // And finally, we start to lazy load. Should bLazy ensure domready?
      (function ready (fn) {
        if (document.readyState != 'loading') {
          fn()
        } else if (document.addEventListener) {
          document.addEventListener('DOMContentLoaded', fn)
        } else {
          document.attachEvent('onreadystatechange', function () {
            if (document.readyState != 'loading')
              fn()
          })
        }
      })(function () {
        self.saveViewportOffset()
        self.validate()
      })
    },
    validate: function () {
      // loadFirst Loading Us the First X Images in the container.
      var itemsLength = this.images.length
      if (!this.force && !this.loadAll && this.options.loadFirst && this.options.loadFirst >= this.loadedImages) {
        itemsLength = this.options.loadFirst >= itemsLength ? itemsLength : this.options.loadFirst - this.loadedImages
      }

      for (var i = 0; i < itemsLength; i++) {
        var image = this.images[i]
        if (typeof image == 'undefined')
          break

        if (!this.force && !this.loadAll && this.options.loadFirst && this.options.loadFirst < this.loadedImages) {
          return
        }

        if (this.elementInView(image) || this.isElementLoaded(image) || this.force) {
          if (this.loadImage(image, this.force)) {
            this.images.splice(i, 1)
            itemsLength = itemsLength - 1
            this.loadedImages++
            i--
          }
        }
      }

      if (this.images.length == 0 && this.imagesStartToLoading == 0 && !this.destroyed) {
        if (this.options.finish) this.options.finish.apply(this,
          [this.options.selector, this.loadedImages, this.imagesLoadSuccessfuly])
        this.destroy()
      }

    },
    destroy: function () {
      var self = this
      if (this.options.container) {
        this.each(this.options.container, function (object) {
          self.unbindEvent(object, 'scroll', self.validateT)
        })
      }
      this.unbindEvent(window, 'scroll', this.validateT)
      this.unbindEvent(window, 'resize', this.validateT)
      this.unbindEvent(window, 'resize', this.saveViewportOffsetT)
      this.count = 0
      this.images = []
      this.destroyed = true
    },
    validateT: function () {
      var fn = this.throttle(this.validate, 25)
      this.validateT = fn
      return fn
    },
    saveViewportOffsetT: function () {
      var fn = this.throttle(this.saveViewportOffset, 25)
      this.saveViewportOffsetT = fn
      return fn
    },
    throttle: function (fn, minDelay) {
      var self = this
      var lastCall = 0
      return function () {
        var now = +new Date()
        if (now - lastCall < minDelay) {
          return
        }
        lastCall = now
        fn.apply(self, arguments)
      }
    },
    loadImage: function (ele, force) {
      var self = this
      // if element is visible
      if (force || (ele.offsetWidth > 0 && ele.offsetHeight > 0)) {

        var dataSrc = ele.getAttribute(this.source) || ele.getAttribute(this.options.src) // fallback to default data-src

        if (dataSrc) {
          var dataSrcSplitted = dataSrc.split(this.options.separator)
          var src = dataSrcSplitted[this.isRetina && dataSrcSplitted.length > 1 ? 1 : 0]
          var img = new Image()
          // cleanup markup, remove data source attributes
          this.each(this.options.breakpoints, function (object) {
            ele.removeAttribute(object.src)
          })
          ele.removeAttribute(this.options.src)
          self.imagesStartToLoading++
          img.onerror = function () {
            if (self.options.error) self.options.error(ele, 'invalid')
            ele.className = ele.className + ' ' + self.options.errorClass
            self.imagesStartToLoading--
          }
          img.onload = function () {
            // Is element an image or should we add the src as a background image?
            ele.nodeName.toLowerCase() === 'img' ? ele.src = src : ele.style.backgroundImage = 'url("' + src + '")'
            ele.className = ele.className + ' ' + self.options.successClass
            self.imagesLoadSuccessfuly++
            self.imagesStartToLoading--
            if (self.options.success) self.options.success.apply(self, [ele])
          }
          img.src = src //preload image

          return true
        } else {
          if (this.options.error) this.options.error.apply(self, [ele, 'missing'])
          ele.className = ele.className + ' ' + this.options.errorClass
          return false
        }
      }
      return false
    },
    elementInView: function (ele) {
      var rect = ele.getBoundingClientRect()
      return (
        // Intersection
        rect.right >= this.viewport.left
        && rect.bottom >= this.viewport.top
        && rect.left <= this.viewport.right
        && rect.top <= this.viewport.bottom
      )
    },
    isElementLoaded: function (ele) {
      return (' ' + ele.className + ' ').indexOf(' ' + this.options.successClass + ' ') !== -1
    },
    createImageArray: function (selector) {
      var nodelist = this.options.parentContainer.querySelectorAll(selector)
      this.count = nodelist.length
      for (var i = this.count; i--; this.images.unshift(nodelist[i])) {
      }
    },
    saveViewportOffset: function () {
      this.viewport.bottom = (window.innerHeight || document.documentElement.clientHeight) + this.options.offset
      this.viewport.right = (window.innerWidth || document.documentElement.clientWidth) + this.options.offset
    },
    bindEvent: function (ele, type, fn) {
      if (ele.attachEvent) {
        ele.attachEvent && ele.attachEvent('on' + type, fn)
      } else {
        ele.addEventListener(type, fn, false)
      }
    },
    unbindEvent: function (ele, type, fn) {
      if (ele.detachEvent) {
        ele.detachEvent && ele.detachEvent('on' + type, fn)
      } else {
        ele.removeEventListener(type, fn, false)
      }
    },
    each: function (object, fn) {
      if (object && fn) {
        var l = object.length
        for (var i = 0; i < l && fn(object[i], i) !== false; i++) {
        }
      }
    },
    allImagesLoaded: function () {
      return this.imagesStartToLoading === 0
    },
    forceLoad: function () {
      var self = this
      this.images.map(function (image) {self.loadImage(image, true)})
    }

  }
  window.lazyLoaderManager = new lazyLoaderManager()

})(window)